import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloLink, from } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory';
import { setContext } from "apollo-link-context";
import { onError } from 'apollo-link-error';
// import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
// import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client';
import { isPast, fromUnixTime } from 'date-fns';
import axios from 'axios';

import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
// import { sha256 } from 'crypto-hash';
import sha256 from 'crypto-js/sha256';

import { trim, compact, get } from '@/helpers';
import store from '@/store';

// Install the vue plugin
Vue.use(VueApollo);

// Name of the localStorage item
// const AUTH_TOKEN = 'member-token';

// const wsEndpoint =
//   `${process.env.VUE_APP_API_WS}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_GRAPHQL_ROUTE}` ||
//   'ws://localhost:4000/graphql';

// const authMiddleware = new ApolloLink((operation, forward) => {
//     // add the authorization to the headers
//     let headers = {
//         Authorization: localStorage.getItem('member-token') ? `Bearer ${localStorage.getItem('member-token')}` : null,
//         'X-Prevent-Token-Refresh': true
//     };
//     const customerGroupKey = get(store.state, 'auth.member.customer.customerGroup.key');
//     if (customerGroupKey) headers['X-Customer-Group'] = customerGroupKey;
//
//     operation.setContext({ headers });
//     return forward(operation).map(response => {
//         const context = operation.getContext();
//         const {
//             response: { headers }
//         } = context;
//
//         if (headers) {
//             const token = headers.get('authorization');
//
//             if (token) {
//                 const jwt = token.split('Bearer');
//                 if (jwt.length) {
//                     const token = compact(jwt)[0].trim();
//                     store.commit('auth/addTokenToState', token);
//                 }
//             }
//         }
//         return response;
//     });
// });

const authMiddleware = setContext(async (request, { headers }) => {
    // add the authorization to the headers
    headers = {
        ...headers,
        Authorization: localStorage.getItem('member-token') ? `Bearer ${localStorage.getItem('member-token')}` : null,
        'X-Prevent-Token-Refresh': true
    };
    const customerGroupKey = get(store.state, 'auth.member.customer.customerGroup.key');
    if (customerGroupKey) headers['X-Customer-Group'] = customerGroupKey;

    let token = localStorage.getItem('member-token')

    const jwt = get(store.state, 'auth.jwt');
    if (token && jwt?.exp && isPast(fromUnixTime(jwt.exp))) {
        const tokenRefreshEndpoint = trim(
            `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_MEMBER_REFRESH_TOKEN_ROUTE}`,
            '/'
        );

        const config = { headers: { Authorization: token ? `Bearer ${token}` : null }};
        const response = await axios.post(tokenRefreshEndpoint, null, config)
        const { data, error, status } = response

        if (status === 200) {
            token = data.token
            headers.Authorization = `Bearer ${token}`
            store.commit('auth/addTokenToState', token)
        } else if ([401, 403, 422].includes(status)) {
            delete headers.Authorization
            localStorage.removeItem('member-token')
            store.commit('auth/authRemove')
        }
    }

    return { headers }
});

const networkErrorLink = onError(parent => {
    const { networkError, graphQLErrors, operation, forward } = parent;

    if (networkError) {
        store.commit('setError', { code: networkError.statusCode, message: networkError.message });
    } else if (graphQLErrors) {
        const message = get(graphQLErrors, '0.debugMessage') || get(graphQLErrors, '0.message');
        switch (message.toLowerCase()) {
            case 'not found':
            case 'not found!':
                store.commit('setError', { code: 404, message: 'Not Found!' });
                break;
            default:
                store.commit('setError', { code: 400, message: 'Bad API request!' });
        }
    } else {
        store.commit('setError', { code: 500, message: 'An unknown error has occured!' });
    }

    return forward(operation);
});

// Config
// const defaultOptions = {
//   // You can use `https` for secure connection (recommended in production)
//   // httpEndpoint,
//
//   // You can use `wss` for secure connection (recommended in production)
//   // Use `null` to disable subscriptions
//   wsEndpoint: null,
//   // LocalStorage token
//   tokenName: AUTH_TOKEN,
//   // Enable Automatic Query persisting with Apollo Engine
//   persisting: false,
//   // Use websockets for everything (no HTTP)
//   // You need to pass a `wsEndpoint` for this to work
//   websocketsOnly: false,
//   // Is being rendered on the server?
//   ssr: false
//
//   // Override default apollo link
//   // note: don't override httpLink here, specify httpLink options in the
//   // httpLinkOptions property of defaultOptions.
//   // link: from([authMiddleware, networkErrorLink])
//
//   // Override default cache
//   // cache: myCache
//
//   // Override the way the Authorization header is set
//   // getAuth: (tokenName) => ...
//
//   // Additional ApolloClient options
//   // apollo: { ... }
//
//   // Client local data (see apollo-link-state)
//   // clientState: { resolvers: { ... }, defaults: { ... } }
// };

const publicEndpoint = trim(
    `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_GRAPHQL_PUBLIC_ROUTE}`,
    '/'
);
// const publicLinkChain = createPersistedQueryLink({
//     sha256: query => sha256(query).toString(),
//     // useGETForHashedQueries: true
// }).concat(new HttpLink({ uri: publicEndpoint }));
const publicLinkChain = new HttpLink({ uri: publicEndpoint });
const publicGetLinkChain = createPersistedQueryLink({
    sha256: query => sha256(query).toString(),
    useGETForHashedQueries: true
}).concat(new HttpLink({
    uri: publicEndpoint,
    // useGETForQueries: true
}));

// const publicClientOptions = {
//   httpEndpoint: publicEndpoint,
//   link: from([publicLinkChain, authMiddleware, networkErrorLink])
// };

const privateEndpoint = trim(
    `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_GRAPHQL_PUBLIC_ROUTE}`,
    '/'
);
// const privateLinkChain = createPersistedQueryLink({
//     sha256: query => sha256(query).toString(),
//     // useGETForHashedQueries: true
// }).concat(new HttpLink({ uri: privateEndpoint }));
const privateLinkChain = new HttpLink({ uri: privateEndpoint });

// const privateClientOptions = {
//   httpEndpoint: privateEndpoint,
//   link: from([privateLinkChain, authMiddleware, networkErrorLink])
// };

// Call this in the Vue app file
export const createProvider = () => {
    // Create public apollo client
    //   const { apolloClient: publicApolloClient, wsClient: publicWsClient } = createApolloClient({
    //     ...defaultOptions,
    //     ...publicClientOptions,
    //     ...options
    //   });
    //   publicApolloClient.wsClient = publicWsClient;
    //
    //   // Create private apollo client
    //   const { apolloClient: privateApolloClient, wsClient: privateWsClient } = createApolloClient({
    //     ...defaultOptions,
    //     ...privateClientOptions,
    //     ...options
    //   });
    //   privateApolloClient.wsClient = privateWsClient;

    const inMemoryCacheConfig = {
        dataIdFromObject: (object) => {
            let id = defaultDataIdFromObject(object);
            switch (object.__typename) {
                case 'CO_ArticleStock':
                case 'CO_PurchasedItemStock':
                    if (object?.pivot?.id) {
                        id = `${object.id}:${object.pivot.id}`
                    }
                    break;
            }
            return id;
        }
    }

    const publicApolloClient = new ApolloClient({
        cache: new InMemoryCache(inMemoryCacheConfig),
        link: from([authMiddleware, publicLinkChain, networkErrorLink])
    });
    const publicGetApolloClient = new ApolloClient({
        cache: new InMemoryCache(inMemoryCacheConfig),
        link: from([authMiddleware, publicGetLinkChain, networkErrorLink])
    });

    const privateApolloClient = new ApolloClient({
        cache: new InMemoryCache(inMemoryCacheConfig),
        link: from([authMiddleware, privateLinkChain, networkErrorLink])
    });

    // Create vue apollo provider
    const apolloProvider = new VueApollo({
        clients: {
            public: publicApolloClient,
            apq: publicGetApolloClient,
            private: privateApolloClient
        },
        defaultClient: publicApolloClient,
        defaultOptions: {
            $query: {
                // fetchPolicy: 'cache-and-network',
            }
        },
        errorHandler(error) {
            // eslint-disable-next-line no-console
            console.log(
                '%cError',
                'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
                error.message
            );
        }
    });

    return apolloProvider;
};

const apolloProvider = createProvider();
export default apolloProvider;

// // Manually call this when user log in
// export async function onLogin(apolloClient, token) {
//   if (typeof localStorage !== 'undefined' && token) {
//     localStorage.setItem(AUTH_TOKEN, token);
//   }
//   if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
//   try {
//     await apolloClient.resetStore();
//   } catch (e) {
//     // eslint-disable-next-line no-console
//     console.log('%cError on cache reset (login)', 'color: orange;', e.message);
//   }
// }
//
// // Manually call this when user log out
// export async function onLogout(apolloClient) {
//   if (typeof localStorage !== 'undefined') {
//     localStorage.removeItem(AUTH_TOKEN);
//   }
//   if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
//   try {
//     await apolloClient.resetStore();
//   } catch (e) {
//     // eslint-disable-next-line no-console
//     console.log('%cError on cache reset (logout)', 'color: orange;', e.message);
//   }
// }
